module.exports = __webpack_public_path__ + "img/4.14b49011.png";